
/* eslint-disable max-lines */
/* eslint-disable vue/no-mutating-props */
// import _ from 'lodash'
import configCard from './config-card.vue';
import { orientation, closeTime, logoPosition, chooseIfOptions } from '@/common/material-metadata';
import { channelList, WX_GAME_CHANNEL_ID } from '@com/utils/channel';
import trafficConfigRadio from '../components/traffic-config-radio';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';

export default {
  name: 'trafficConfig',
  components: {
    configCard: configCard
  },
  props: {
    channelId: {
      type: Number,
      default: 0
    },
    formConfig: {
      type: Object,
      required: true
    },
    schemeValue: {
      type: Object,
      default: function _default() {}
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      formValue: {
        orientation: 3, // 默认自适应
        orientation_text: '-',
        category_id: '',
        category_text: '-',
        close_time: 15,
        close_time_text: '-',
        logo_position: 1, // 默认为左
        logo_position_text: '-',
        add_loading: 1,
        add_loading_text: '-',
        add_logo: 0,
        add_logo_text: '-',
        language_text: ''
      }
    };
  },

  computed: {
    title: function title() {
      return useValueExchangeLabel(this.channelId, channelList);
    },
    isMintegral: function isMintegral() {
      return this.channelId === 1 || this.channelId === 2 || this.channelId === 21;
    },
    formItemList: function formItemList() {
      var _this = this;

      var list = [{
        // 除了 4, 22, 23, 24, 25, 26, 11, 19,27, 28, 29, 30, 31, 20, 32,33 渠道之外，其他渠道都显示展示方向
        visible: function visible() {
          var disabledOrientationChannel = [4, 22, 23, 24, 25, 26, 11, 19, 27, 28, 29, 30, 31, 20, 32, 33, 35];
          return disabledOrientationChannel.indexOf(_this.channelId) === -1 && !_this.readOnly;
        },
        label: '展示方向：',
        type: 'radio-group',
        prop: 'orientation',
        rules: [{
          required: true,
          message: '请选择展示方向',
          trigger: 'blur'
        }],
        params: {
          // 只有facebook渠道不允许编辑
          disabled: this.channelId === 3,
          options: orientation,
          button: true
        }
      }, {
        visible: function visible() {
          var disabledOrientationChannel = [4, 19, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 20, 33, 35];
          return disabledOrientationChannel.indexOf(_this.channelId) === -1 && _this.readOnly;
        },
        label: '展示方向：',
        type: 'plain-text',
        prop: 'orientation_text'
      }, {
        // 只有MTG和Mintegral有关闭时间
        visible: (this.channelId === 1 || this.channelId === 21) && !this.readOnly,
        label: '关闭时间：',
        component: trafficConfigRadio,
        prop: 'close_time',
        rules: [{
          required: true,
          message: '请选择关闭时间',
          trigger: 'change'
        }],
        params: {
          disabled: false,
          options: closeTime,
          button: true,
          channelId: this.channelId,
          tip: '（针对sdk流量）'
        }
      }, {
        visible: (this.channelId === 1 || this.channelId === 21) && this.readOnly,
        label: '关闭时间：',
        type: 'plain-text',
        prop: 'close_time_text'
      }, {
        // 所有渠道都可以添加loading，但是某些渠道不允许编辑
        visible: !this.readOnly,
        label: '添加loading：',
        type: 'radio-group',
        prop: 'add_loading',
        rules: [{
          required: true,
          message: '请选择是否需要添加Loading',
          trigger: 'change'
        }],
        params: {
          // MTG/DSP/今日头条/穿山甲/Mintegral都不允许编辑
          disabled: this.channelId === 1 || this.channelId === 2 || this.channelId === 8 || this.channelId === 9 || this.channelId === 21 || this.channelId === WX_GAME_CHANNEL_ID,
          options: chooseIfOptions,
          button: true
        }
      }, {
        visible: this.readOnly,
        label: '添加loading：',
        type: 'plain-text',
        prop: 'add_loading_text'
      }, {
        // 所有渠道都可以添加logo，但是某些渠道不允许编辑
        visible: !this.readOnly,
        label: '添加logo：',
        type: 'radio-group',
        prop: 'add_logo',
        rules: [{
          required: true,
          message: '请选择是否需要添加Logo',
          trigger: 'change'
        }],
        params: {
          // MTG/DSP/今日头条/穿山甲/Mintegral都不允许编辑
          disabled: this.channelId === 1 || this.channelId === 2 || this.channelId === 8 || this.channelId === 9 || this.channelId === 21 || this.channelId === WX_GAME_CHANNEL_ID,
          options: chooseIfOptions,
          button: true
        }
      }, {
        visible: this.readOnly,
        label: '添加logo：',
        type: 'plain-text',
        prop: 'add_logo_text'
      }, {
        visible: (this.channelId === 1 || this.channelId === 21) && !this.readOnly,
        label: 'logo位置：',
        component: trafficConfigRadio,
        prop: 'logo_position',
        rules: [{
          required: true,
          message: '请选择logo位置',
          trigger: 'change'
        }],
        params: {
          disabled: false,
          options: logoPosition,
          button: true,
          channelId: this.channelId,
          tip: '（针对sdk流量）'
        }
      }, {
        visible: (this.channelId === 1 || this.channelId === 21) && this.readOnly,
        label: 'logo位置：',
        type: 'plain-text',
        prop: 'logo_position_text'
      }, {
        label: '投放语言：',
        type: 'plain-text',
        prop: 'language_text'
      }];
      return list;
    }
  },
  watch: {
    'formValue.close_time': function formValueClose_time(val) {
      this.schemeValue.close_time = val;
    },
    'formValue.orientation': function formValueOrientation(val) {
      this.schemeValue.orientation = val;
    },
    'formValue.logo_position': function formValueLogo_position(val) {
      this.schemeValue.logo_position = val;
    },
    'formValue.add_loading': function formValueAdd_loading(val) {
      this.schemeValue.add_loading = val;
    },
    'formValue.add_logo': function formValueAdd_logo(val) {
      this.schemeValue.add_logo = val;
    }
  },
  methods: {
    validate: function validate(cb) {
      return this.$refs.form.validate(cb);
    },
    fillForm: function fillForm() {
      this.formValue.orientation = this.schemeValue.orientation;
      this.formValue.orientation_text = useValueExchangeLabel(this.schemeValue.orientation, orientation);
      this.formValue.close_time = this.schemeValue.close_time;
      this.formValue.close_time_text = useValueExchangeLabel(this.schemeValue.close_time, closeTime);
      this.formValue.logo_position = this.schemeValue.logo_position;
      this.formValue.logo_position_text = useValueExchangeLabel(this.schemeValue.logo_position, logoPosition);
      this.formValue.add_loading = this.schemeValue.add_loading;
      this.formValue.add_loading_text = useValueExchangeLabel(this.schemeValue.add_loading, chooseIfOptions);
      this.formValue.add_logo = this.schemeValue.add_logo;
      this.formValue.add_logo_text = useValueExchangeLabel(this.schemeValue.add_logo, chooseIfOptions);
      this.formValue.language_text = this.schemeValue.languages.join() || '-';
    }
  },
  mounted: function mounted() {
    this.fillForm();
  }
};